<template>
  <div class="memberIndex">
    <div class="right">
      <div class="currentMenu"></div>
      <div class="right_content">
        <div class="change_inform">
          <div class="title">逾期考核跟进</div>
        </div>
        <div class="right_out">
          <div class="header-wrap">
            <div class="header-right">
              <el-button style="float: right" @click="show">高级查询</el-button>
              <div class="AdvancedQuery" style="margin: 15px">
                <div class="search-form-wrap" v-show="searchFormShow">
                  <table style="width: 100%">
                    <tbody>
                      <tr>
                        <td class="tdtitle">
                          <span>计划编号:</span>
                        </td>
                        <td class="tdcontents">
                          <el-input class="input" v-model="Query.PlanCode"></el-input>
                        </td>
                        <td class="tdtitle">
                          <span>货物名称:</span>
                        </td>
                        <td class="tdcontents">
                          <el-input class="input" v-model="Query.SupplierInstrumentName"></el-input>
                        </td>
                        <td class="tdtitle">
                          <span>品牌:</span>
                        </td>
                        <td class="tdcontents">
                          <el-input class="input" v-model="Query.Trademark"></el-input>
                        </td>
                        <td class="tdtitle">
                          <span>规格型号:</span>
                        </td>
                        <td class="tdcontents">
                          <el-input class="input" v-model="Query.SupplierSpecification"></el-input>
                        </td>
                      </tr>
                      <tr>
                        <td class="tdtitle">
                          <span>甲方:</span>
                        </td>
                        <td class="tdcontents">
                          <el-select collapse-tags filterable v-model="Query.CompanyCode">
                            <el-option v-for="item in companyList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                          </el-select>
                        </td>

                        <td class="tdtitle">
                          <span>合同编号:</span>
                        </td>
                        <td class="tdcontents">
                          <el-input class="input" v-model="Query.ContractNumber"></el-input>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div class="text">
                    <el-button @click="fnReset">重置</el-button>
                    <el-button @click="fnGetData">搜索</el-button>
                    <el-button @click="close">关闭</el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <el-table
            class="table_wrap1"
            :data="technicalList"
            :height="height"
            @selection-change="handleSelectionChange"
            :selectable="handleDisabledSelection"
          >
            <el-table-column prop="ArrivalExamineState" label="逾期考核状态" width="120"></el-table-column>
            <el-table-column prop="EstimateArrivalDate" label="合同约定到货日期" width="120"></el-table-column>
            <el-table-column prop="ActualArrivalDate" label="实际到货日期" width="120"></el-table-column>
            <el-table-column prop="LateDeliveryDate" label="逾期天数" width="120"> </el-table-column>
            <el-table-column prop="PlanCode" label="计划编号" width="150"></el-table-column>
            <el-table-column prop="SupplierInstrumentName" label="货物名称" width="150"></el-table-column>
            <el-table-column prop="Trademark" label="品牌" width="120"></el-table-column>
            <el-table-column prop="SupplierSpecification" label="规格型号" width="220"></el-table-column>
            <el-table-column prop="Price" label="单价（元）" width="150"></el-table-column>
            <el-table-column prop="Count" label="数量" width="80"></el-table-column>
            <el-table-column prop="SumFee" label="金额总计（元）" width="120"></el-table-column>
            <el-table-column prop="ShouldExamineAmount1" label="合同约定应追究违约金额（元）" width="120"></el-table-column>
            <el-table-column prop="CompanyName" label="甲方" width="220"></el-table-column>
            <el-table-column prop="ContractNumber" label="合同编号" width="220">
              <template slot-scope="scope">
                <el-link @click="fnGoDetail(scope.row.ContractId)" :underline="false" type="primary" target="_blank">
                  {{ scope.row.ContractNumber }}</el-link
                >
              </template>
            </el-table-column>
          </el-table>

          <el-pagination
            style="text-align: center"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="pageSizes"
            :page-size="PageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <AuditProgress :flowcodes="flowcodes" :fkvalue="fkvalue" :auditProgressShow.sync="auditProgressShow" :isDialogShow="true"></AuditProgress>
  </div>
</template>

<script>
import AuditProgress from '@/views/Common/AuditProgress.vue'
export default {
  components: {
    AuditProgress
  },
  props: {
    params: Number
  },
  data() {
    return {
      activeName: '1',
      searchFormShow: false,
      selected: [],
      Query: {
        PlanCode: '',
        IsArrival: '',
        IsLateDelivery: '',
        AuditState: '',
        SupplierInstrumentName: '',
        SupplierSpecification: '',
        Trademark: '',
        ContractNumber: '',
        CompanyCode: ''
      },
      flowcodes: '',
      fkvalue: '',
      auditProgressShow: false,
      technicalList: [],
      currentPage: 1,
      // 总条数，根据接口获取数据长度(注意：这里不能为空)
      totalCount: 1,
      // 个数选择器（可修改）
      pageSizes: [10, 25, 50, 100],
      // 默认每页显示的条数（可修改）
      PageSize: 25,
      height: window.innerHeight - 222,
      companyList: [],
      auditStateList: [],
      contractAcceptanceStateList: [],
      contractInvoiceStateList: [],
      paymentTypeList: [],
      multipleSelection: []
    }
  },
  watch: {
    activeName() {
      this.fnGetData()
    }
  },
  mounted() {
    console.log(this.params)
    this.fnGetData()
    this.fnInit()
    window.addEventListener('storage', (e) => {
      let that = this
      if (e.key == 'technicalList') {
        localStorage.removeItem('technicalList')
        this.fnGetData()
      }
    })
  },
  methods: {
    show() {
      this.searchFormShow = !this.searchFormShow
    },
    close() {
      this.searchFormShow = false
    },
    fnGetData() {
      this.Query.type = this.params
      this.Query.listType = this.activeName
      this.Query.PageSize = this.PageSize
      this.Query.currentPage = this.currentPage
      let config = {
        params: {
          Query: JSON.stringify(this.Query)
        }
      }
      this.getRequest('/Contract/AcceptanceFollowList', config)
        .then((res) => {
          if (res.data.errcode == 0) {
            this.technicalList = res.data.technicalList
            this.totalCount = res.data.count
            this.close()
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    fnInit() {
      // //获取登录供应商基础信息

      let config = {
        params: {
          PurchaseMethod: JSON.stringify(this.ownPurchaseMethod)
        }
      }
      //获取下拉列表
      this.getRequest('Contract/GetQueryList', config)
        .then((res) => {
          if (res.data.errcode == 0) {
            this.companyList = res.data.Companys
            this.auditStateList = res.data.auditStateList
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    // 分页
    // 每页显示的条数
    handleSizeChange(val) {
      // 改变每页显示的条数
      this.PageSize = val
      // 注意：在改变每页显示的条数时，要将页码显示到第一页
      this.currentPage = 1
      this.fnGetData()
    },
    // 显示第几页
    handleCurrentChange(val) {
      // 改变默认的页数
      this.currentPage = val
      this.fnGetData()
    },
    fnEditContract(contractId) {
      let routerData = this.$router.resolve({
        name: 'EditContract',
        query: {
          contractId: contractId
        }
      })
      window.open(routerData.href, '_blank')
    },
    fnUploadContractFile(contractId) {
      let routerData = this.$router.resolve({
        name: 'UploadContractFile',
        query: {
          contractId: contractId
        }
      })
      window.open(routerData.href, '_blank')
    },
    fnEditInvoice(contractId) {
      let routerData = this.$router.resolve({
        name: 'EditInvoice',
        query: {
          contractId: contractId
        }
      })
      window.open(routerData.href, '_blank')
    },
    fnInvoice(contractId) {
      let routerData = this.$router.resolve({
        name: 'InvoiceUpload',
        query: {
          contractId: contractId,
          invoiceId: '',
          isDetail: false
        }
      })
      window.open(routerData.href, '_blank')
    },
    showFlowDetail(flowCode, fkvalue) {
      this.flowcodes = flowCode
      this.fkvalue = fkvalue
      this.auditProgressShow = true
    },
    fnGoDetail(contractId) {
      let routerData = this.$router.resolve({
        name: 'ContractDetail',
        query: {
          contractId: contractId
        }
      })
      window.open(routerData.href, '_blank')
    },

    fnArrivalConfirm() {
      if (this.multipleSelection.length == 0) {
        this.$message.error(`请选择要到货确认的设备`)
        return
      }
      let isPass = true
      let projectIdList = []
      this.multipleSelection.forEach((item) => {
        projectIdList.push(item.ProjectId)
        if (item.ContractId != this.multipleSelection[0].ContractId) {
          isPass = false
        }
      })
      if (isPass == false) {
        this.$message.error(`请选择同一合同下的设备进行到货确认`)
        return
      }

      let routerData = this.$router.resolve({
        name: 'ArrivalConfirm',
        query: {
          contractId: this.multipleSelection[0].ContractId,
          projectId: projectIdList.join(',')
        }
      })
      window.open(routerData.href, '_blank')
    },
    fnReset() {
      this.Query = {
        PlanCode: '',
        IsArrival: '',
        IsLateDelivery: '',
        AuditState: '',
        SupplierInstrumentName: '',
        SupplierSpecification: '',
        Trademark: '',
        ContractNumber: '',
        CompanyCode: ''
      }
    },
    fnDownload(fileId) {
      let token = window.localStorage.getItem('loginToken')
      var url = '/Common/DownloadFile?FileId=' + fileId + '&token=' + token + '&FileName='
      this.downloadfile(this.baseURL + url)
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    handleDisabledSelection(row) {
      return row.AuditState1 == 0 || row.AuditState1 == 2
    }
  }
}
</script>

<style scoped lang="scss">
.memberIndex {
  display: flex;

  .left {
    width: 250px;
    min-width: 250px;
    background: #4f99d7;

    .logined_wrap {
      padding: 10px;

      .title span:nth-of-type(1) {
        font-weight: bold;
        color: #fff;
        margin-right: 5px;
      }

      .btn {
        border-top: 1px dashed #2db7f5;
        padding-top: 10px;
        margin-top: 10px;
      }

      .img {
        margin-left: 30px;
      }

      .list {
        li {
          font-size: 12px;
          padding: 5px 0;
          color: #d3e7f3;
          display: flex;
          align-items: center;

          .labell {
            font-weight: bold;
          }

          img {
            margin-right: 5px;
          }
        }
      }
    }
  }

  .right {
    width: 100%;
    background: #e4e4e4;
    // flex: 1;
    padding: 0 0 10px 0;

    .right_out {
      width: 98%;
      margin: 0 auto;
    }

    .currentMenu {
      margin: 16px 5px;
    }

    .right_content {
      margin: 0 10px;
      // height: 93%;
      background: #f7f7f7;
      padding-bottom: 10px;
    }

    #search {
      width: 120px;
    }

    .input {
      width: 180px;
      margin-left: 5px;
    }

    ::v-deep.el-input--mini .el-input__inner {
      height: 28px;
      line-height: 28px;
    }

    .btn_wrap {
      .btn {
        margin: auto;
        color: #6a96bc;
        border: 1px solid #6a96bc;
        border-radius: 5px;
        padding: 2px 18px;
      }
    }
  }
}

.btn_2 {
  float: right;
  border-radius: 6px;
  margin-top: 4px;
  margin-right: 5px;
}
</style>